


















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Notes extends Vue {
  @Prop() notes!: string;
  /**
   * Have to explicitly call vuelidate ($v) methods if not using v-model
   */
  public updateItem(fieldValue: string, fieldName: string) {
    this.$emit(`update:${fieldName}`, fieldValue);
  }
}
